import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Fields, reduxForm, reset } from 'redux-form';
import DOMPurify from 'dompurify';
import { Button, Modal, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  TextInput,
  TextArea,
  Select,
  FormErrorMessages,
  generateValidation,
} from 'ecs-react-components/dist/index.es';
import validations from './SecureMessageForm.validations';
import { messages } from './SecureMessageForm.i18n';
import { loadLegalMessage, sendSecureMessage } from '../../redux/modules/secure-message/secure-message-middleware';


const fields = ['recipient', 'subject', 'content'];

class SecureMessageForm extends Component {
  componentDidMount() {
    this.props.dispatch(loadLegalMessage(this.props.facility.facilityId, this.props.languageCode));
  }

  onSubmit = (formValues) => {
    const { userId, languageCode, timeZone, timeZoneOffset, dispatch } = this.props;
    dispatch(sendSecureMessage({
      patientId: this.props.patient.patientId,
      careProviderId: formValues.recipient,
      subjectText: formValues.subject,
      messageText: formValues.content,
      userId,
      successRoute: !this.props.initiatedfromMessagesModule ? '/dashboard' : null,
      languageCode,
      timeZone,
      timeZoneOffset,
      compact: this.props.compact,
    }));
    this.props.close();
  }

  createLegalMessageMarkup = () => {
    const html = { __html: DOMPurify.sanitize(this.props.legalMessage) };
    return html;
  };

  close = () => {
    this.props.dispatch(reset('securemessageform'));
    this.props.close();
  }

  renderFields = (fieldsMeta) => {
    const { formatMessage } = this.props.intl;
    const { recipient, subject, content } = fieldsMeta;
    const hasSecureMessaging = (person) =>
      person &&
      person.preferredSecureMessageIfSystemId &&
      person.secureMessageRecipientForPatient;

    const careTeamWithSecureMessaging = this.props.careTeam ? this.props.careTeam.filter(hasSecureMessaging) : [];
    const careTeamSelectOptions = careTeamWithSecureMessaging.map((member) => {
      const option = {};
      option.key = member.careProviderId;
      option.value = member.careProviderId;
      option.displayValue = member.firstName + ' ' + member.lastName;
      return option;
    });
    return (
      <div>
        <div className="form-group mb-3">
          <Form.Label htmlFor={recipient.input.name} >
            {formatMessage(messages.recipient.placeholder)}
            <FormErrorMessages field={recipient} />
          </Form.Label>
          <Select
            field={recipient}
            options={careTeamSelectOptions}
            selectClass="form-select"
          />
        </div>
        <div className="form-group mb-3">
          <Form.Label htmlFor={subject.input.name}>
            {formatMessage(messages.subject.placeholder)}
            <FormErrorMessages field={subject} />
          </Form.Label>
          <TextInput
            field={subject}
            maxLength={validations.subject.maxLength}
          />
        </div>
        <div className="form-group mb-3">
          <Form.Label htmlFor={content.input.name}>
            {formatMessage(messages.content.placeholder)}
            <FormErrorMessages field={content} />
          </Form.Label>
          <TextArea field={content} placeholder={formatMessage(messages.message.placeholder)}
            rows={5} maxLength={validations.content.maxLength}
          />
        </div>
      </div>
    );
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { handleSubmit } = this.props;

    return (
      <Modal show={this.props.showModal} onHide={ this.close } backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{formatMessage(messages.page.header)}</Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit(this.onSubmit)}>
        <Modal.Body>
          <p dangerouslySetInnerHTML={ this.createLegalMessageMarkup() }>
          </p>
          <Fields names={fields} component={this.renderFields} />
        </Modal.Body>
        <Modal.Footer>
              <Button type="submit">
                <FormattedMessage {...messages.send.label} />
              </Button>
              <Button type="button" variant="outline-secondary" onClick={ this.close }>
                <FormattedMessage {...messages.cancel.label} />
              </Button>
        </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

SecureMessageForm.propTypes = {
  intl: PropTypes.object,
  patient: PropTypes.object,
  facility: PropTypes.object,
  dispatch: PropTypes.func,
  careTeam: PropTypes.array,
  legalMessage: PropTypes.string,
  handleSubmit: PropTypes.func,
  recipient: PropTypes.string,
  userId: PropTypes.string,
  showModal: PropTypes.bool,
  close: PropTypes.func,
  initiatedfromMessagesModule: PropTypes.bool,
  timeZone: PropTypes.string,
  timeZoneOffset: PropTypes.string,
  languageCode: PropTypes.string,
  compact: PropTypes.bool,
};

const formConfig = {
  form: 'securemessageform',
  ...generateValidation(validations),
};

const mapStateToProps = (state) => ({
  patient: state.profile.patient,
  facility: state.facility,
  careTeam: state.careTeam.members,
  legalMessage: state.secureMessage.legalMessage,
  userId: state.profile.user.userId,
  timeZone: state.facility.timeZoneAbbreviation,
  timeZoneOffset: state.facility.timeZoneOffset,
  languageCode: state.language.languageCode,
});

export default reduxForm(formConfig)(connect(mapStateToProps)(injectIntl(SecureMessageForm)));
